import React from "react";
import "./styles/ProjectCard.css";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import Button from "./ui/Button";
const StyledProjectCard = styled.div`
  min-width: 20em;
  max-width: 30em;
  height: auto;
  position: relative;
  cursor: pointer;
  transform-style: preserve-3d;
  transition:300ms ease-in-out;
  overflow:hidden;
  &>div>button{
  transform-style: preserve-3d;
  }
  &:hover{  
    transform:translate3d(0px,-1em,5em);
    box-shadow: 1px 1px 20px rgba(58, 57, 57, 0.575);
  }
  
  & > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
    opacity: 0;
  }
  & > div:hover {
    opacity: 1;
    background-color: rgb(213, 219, 126);
    transition: opacity 0.3s;
  }

  @media (min-width: 1200px) {
    & {
      height: 20em;
      position: relative;
      box-shadow: 1px 1px 10px rgba(58, 57, 57, 0.575);
    }
  }
`;

const ProjectCard = ({ imagen, titulo, trabajoid }) => {
  return (
    <>
      <Link to={`/works/${trabajoid}`}>
        <StyledProjectCard>
          <img className="img-fit" src={imagen} alt="" />
          <div>
            <Button to={`/works/${trabajoid}`} type="button">
              Ver proyecto
            </Button>
          </div>
        </StyledProjectCard>
        <h4>{titulo}</h4>
      </Link>
    </>
  );
};

export default ProjectCard;
